import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';

import {environment} from '../../../environments/environment';
import {OauthLinkedIn} from '../../modules/oauth-linkedin/oauth-linkedin.component';
import {AuthService} from '../auth/auth.service';
import * as Cookies from 'js-cookie';
import constants from 'src/app/shared/constants';
import {JwtHelperService} from '@auth0/angular-jwt';
import {QueryStringService} from '@xref/ngx';
import Constants from '../../shared/constants';
import {IdService} from "../id/id.service";

@Injectable()
export class OauthService {
    constructor(
        private http: HttpClient,
        private auth: AuthService,
        private id: IdService,
        private jwtHelper: JwtHelperService,
        private qs: QueryStringService
    ) {}

    get httpOptions() {
        return {
            headers: new HttpHeaders({
                'X-JWT': `JWT ${this.id.ent_9105 ? this.id.getAuthToken() : Cookies.get(constants.AUTH_TOKEN)}`
            })
        };
    }

    getCheckrStateParam() {
        const checkrState = this.qs.getParam('state').split(':');

        return {
            companyId: checkrState[0],
            region: (checkrState[1] || 'au')
        };
    }

    connectCheckr(data: any): Observable<any> {
    // Because this is a one-time flow for the user, the Auth.url is not set to the region
        const region = this.getCheckrStateParam().region;
        this.auth.setRegionalUrl(region);

        return this.http.post(
            `${this.auth.url}oauth/checkr`,
            data,
            this.httpOptions
        );
    }

    checkrAppRedirect() {
        location.assign(environment.OAUTH_CHECKR_REDIRECT);
    }

    connectLinkedIn(data: OauthLinkedIn, signature: string): Observable<any> {
        const token = this.jwtHelper.decodeToken(this.id.ent_9105 ? sessionStorage.getItem(constants.AUTH_TOKEN)
            : Cookies.get(constants.AUTH_TOKEN));

        let region = 'au';
        if (token && token.hasOwnProperty('region')) {
            region = token.region;
        }
        return this.http.post(
            `${this.auth.makeRegionalUrl(region, environment.LINKED_IN_API)}linkedin/onboarding`,
            data,
            {
                headers: new HttpHeaders({
                    'X-JWT': `JWT ${this.id.ent_9105 ? this.id.getAuthToken() : Cookies.get(constants.AUTH_TOKEN)}`,
                    'X-LI-Signature': signature
                })
            }
        );
    }

    connectOpenApi(clientId: number, state?: string): Observable<any> {
        let queryStr = '';

        if (state) queryStr = `?state=${state}`;

        return this.http.post(
            `${this.auth.url}oauth/open/${clientId}${queryStr}`,
            {},
            this.httpOptions
        ).pipe(map(res => res));
    }

    redirect(url: string) {
        location.assign(url);
    }
}
